import React, {Component} from 'react';
import PropTypes from 'prop-types';
import '../../../../members/client-member-list.css';
import Translate from '../../../../../../../../components/Translate';
import {deleteSkillFromOperator, signSkillToOperator} from "../../../../../../../../services/company/api";
import config from "../../../../../../../../config";
import {handleElementSelect, handleSelectAll} from "../../../../../../../../utils/ComponentUtilFunctions";
import {filterElements} from "../../../../../../../../utils/General";
import colors from "../../../../../../../../utils/Colors";
import TableAction from "../../../../../../../../components-new/table/TableAction";
import MinusIcon from "../../../../../../../../assets/icons/MinusIcon";
import SilverButton from "../../../../../../../../components-new/buttons/SilverButton";
import ContactAvatar from "../../../../../../../../components-new/general/ContactAvatar";
import Checkbox from "../../../../../../../../components-new/form/Checkbox";
import SearchInput from "../../../../../../../../components-new/form/SearchInput";
import DropdownSelect from "../../../../../../../../components-new/form/DropdownSelect";
import TableScroll from "../../../../../../../../components-new/table/TableScroll";

const searchBackgroundColorStyle = {
    backgroundColor: 'transient',
};


class ConnectedMembers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nameFilter: '',
            selectedIds: [],
            operatorSkills: this.initializeOperatorSkills(props.connectedMembers),
            isModifyingSkill: false,
        };
        this.handleSelectAll = handleSelectAll(this.getFilteredMembers, this);
        this.handleMemberSelect = handleElementSelect.bind(this);
    }

    initializeOperatorSkills = (members) => {
        const {client, skills} = this.props;

        return members.reduce((acc, member) => {
            if (!member.skills) return acc;

            acc[member.id] = member.skills
                .filter(s => s.companyId === client.id)
                .map(skill => {
                    const matchedSkill = skills.find(s => s.id === skill.id);
                    return {
                        ...skill,
                        name: matchedSkill ? matchedSkill.name : skill.name
                    };
                });

            return acc;
        }, {});
    };

    componentDidUpdate(prevProps) {
        if (prevProps.connectedMembers !== this.props.connectedMembers) {
            this.setState({
                operatorSkills: this.initializeOperatorSkills(this.props.connectedMembers),
            });
        }
    }

    getFilteredMembers = () => {
        const {connectedMembers} = this.props;
        const {selectedIds} = this.state;

        return filterElements(connectedMembers, '', member => selectedIds.includes(member.id));
    };

    handleNameFilterChange = (text) => {
        this.setState({nameFilter: text});
    };

    filterByName = () => {
        const {nameFilter} = this.state;

        return this.getFilteredMembers().filter(op => {
            return (op.firstName + " " + op.lastName).toLowerCase().includes(nameFilter.toLowerCase())
        });
    }

    removeSelectedMembers = () => {
        const {connectedMembers} = this.props;
        const {selectedIds} = this.state;
        const selectedMembers = connectedMembers.filter(member => selectedIds.includes(member.id));
        this.removeMembersFromClient(selectedMembers);
    };

    removeMembersFromClient = (members) => {
        const {removeMembersFromClient, client} = this.props;
        removeMembersFromClient(members, client).then(() => {
            const {selectedIds} = this.state;
            this.setState({
                selectedIds: selectedIds.filter(id => members.findIndex(member => member.id === id) === -1),
            });
        });
    };

    addSkillToMember = (operatorId, selectedSkillId) => {
        const {connectedMembers} = this.props
        let selectedSkill;

        this.props.skills.map(skill => {
            if (skill.id == selectedSkillId) {
                selectedSkill = skill;
            }
        })

        if (!selectedSkill) {
            return;
        }

        this.setState({
            isModifyingSkill: true,
        });

        signSkillToOperator(operatorId, selectedSkillId).then(() => {
            connectedMembers.filter(cm => cm.id === operatorId)[0].skills.push(selectedSkill)
            this.setState((prevState) => ({
                operatorSkills: {
                    ...prevState.operatorSkills,
                    [operatorId]: [
                        ...(prevState.operatorSkills[operatorId] || []),
                        selectedSkill,
                    ],
                },
            }));
        }).catch((error) => {
            console.error('Error signing skill to operator:', error);
        }).finally(() => {
            this.setState({isModifyingSkill: false});
        });
    };

    removeSkillFromMember = (operatorId, skillId) => {
        const {connectedMembers} = this.props;

        this.setState({
            isModifyingSkill: true,
        });

        deleteSkillFromOperator(operatorId, skillId).then(() => {
            const operator = connectedMembers.find(cm => cm.id === operatorId);
            if (operator) {
                operator.skills = operator.skills.filter(skill => skill.id !== skillId);
            }

            this.setState((prevState) => ({
                operatorSkills: {
                    ...prevState.operatorSkills,
                    [operatorId]: prevState.operatorSkills[operatorId].filter(skill => skill.id !== skillId),
                },
            }));
        }).catch((error) => {
            console.error('Error removing skill from operator:', error);
        }).finally(() => {
            this.setState({
                isModifyingSkill: false,
            });
        });
    };

    render() {
        const {nameFilter, selectedIds, operatorSkills} = this.state;
        const {skills, user, client, tariff} = this.props;
        const filteredMembers = this.filterByName();

        const {features} = tariff;

        skills.filter(skill => skill.companyId === client.id);

        return (
            <div style={{display: 'flex', flexDirection: 'column', padding: '20px', minHeight: '50vh', height: '100%'}}>
                <div style={{marginBottom: '20px', display: 'flex', gap: '20px', justifyContent: 'center'}}>
                    <SearchInput
                        containerStyle={{flexGrow: 1, maxWidth: '480px'}}
                        value={nameFilter}
                        onChange={(e) => this.handleNameFilterChange(e.target.value)}
                        placeholder={'searchByOperator'}
                    />
                </div>

                <TableScroll style={{minHeight: 0}} stickyActions>
                    <table className="custom-table client-members-table">
                        <thead>
                        <tr className="table-head">
                            <th className="client-members-table__checkbox-column">
                                <Checkbox
                                    checked={filteredMembers.length === selectedIds.length && filteredMembers.length}
                                    handleChange={this.handleSelectAll}
                                />
                            </th>
                            <th>
                                <div style={searchBackgroundColorStyle}>
                                    <Translate text="operator"/>
                                </div>
                            </th>

                            {features.includes(config.features.SKILLS) && (
                                <th style={{textAlign: 'center'}}><Translate text="skills"/></th>
                            )}

                            <th style={{textAlign: "center"}}>
                                <SilverButton
                                    width="auto"
                                    height="32px"
                                    styles={{
                                        visibility: selectedIds.length > 0 ? 'visible' : 'hidden',
                                        fontSize: '11px',
                                        margin: '0 auto'
                                    }}
                                    onClick={this.removeSelectedMembers}
                                >
                                    <Translate text="remove"/>{` (${selectedIds.length})`}
                                </SilverButton>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        {filteredMembers.length === 0 && (
                            <tr className="table-no-result">
                                <td
                                    className="client-members-table__empty"
                                    colSpan={features.includes(config.features.SKILLS) ? 4 : 3}
                                >
                                    <Translate text="noResultsFound"/>
                                </td>
                            </tr>
                        )}
                        {filteredMembers.map((member, index) => (
                            <tr key={member.id} className="body-row">
                                <td className="checkbox-header client-members-table__checkbox-column">
                                    <Checkbox
                                        checked={selectedIds.includes(member.id)}
                                        handleChange={this.handleMemberSelect(member.id)}
                                    />
                                </td>

                                <td className="user-info">
                                    <div style={{display: 'flex', alignItems: 'center', gap: '11px'}}>
                                        <ContactAvatar contact={member}/>
                                        <div style={{display: 'flex', flexDirection: 'column'}}>
                                            <span
                                                className="name-text">{`${member.firstName} ${member.lastName}`}</span>
                                            <span className="email-text">{member.email}</span>
                                        </div>
                                    </div>
                                </td>

                                {features.includes(config.features.SKILLS) && (
                                    <td className="client-members-table__skills-cell">
                                        <div className="client-members-table__skills-control">
                                            <DropdownSelect
                                                /* fixed rather than absolute: this one
                                                   sits in a table cell, and in the flow
                                                   it grows the page when it opens on the
                                                   last row */
                                                overlay
                                                selectedValue={operatorSkills[member.id].map(s => ({value: s.id}))}
                                                options={skills.map(s => ({value: s.id, label: s.name}))}
                                                onChange={skill => {
                                                    if (operatorSkills[member.id] && operatorSkills[member.id].some(s => s.id === skill.value)) {
                                                        this.removeSkillFromMember(member.id, skill.value);
                                                    } else {
                                                        this.addSkillToMember(member.id, skill.value);
                                                    }
                                                }}
                                                renderLabel={(val) => {
                                                    return (
                                                        <span>
                                                        {
                                                            val.length === 0 ?
                                                                <span style={{color: colors.silverDark}}><Translate
                                                                    text={'skills'}/></span>
                                                                :
                                                                <span
                                                                    style={{color: 'var(--ds-text-primary)'}}><Translate
                                                                    text={'skills'}/> {'(' + val.length + ')'}</span>
                                                        }
                                                    </span>
                                                    )
                                                }}
                                                searchBy={(option, search) =>
                                                    !search || option.label.toLowerCase().includes(search.toLowerCase())
                                                }
                                                variant={'outline'}
                                                styles={{
                                                    width: '300px',
                                                }}
                                                disabled={this.state.isModifyingSkill}
                                                direction={(filteredMembers.length - index > 4 || index === 0) ? 'bottom' : 'top'}
                                                overlay
                                            />
                                        </div>
                                    </td>
                                )}
                                <td className="add-cell">
                                    <TableAction
                                        tone="danger"
                                        tooltip={'disconnect'}
                                        onClick={() => this.removeMembersFromClient([member])}
                                        icon={<MinusIcon width={18} height={18} stroke="currentColor"/>}
                                    />
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </TableScroll>

            </div>
        );
    }
}

ConnectedMembers.propTypes = {
    connectedMembers: PropTypes.array.isRequired,
    client: PropTypes.object.isRequired,
    removeMembersFromClient: PropTypes.func.isRequired,
};

export default ConnectedMembers;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/operators/components/ConnectedMembers.jsx